import type { ShipmentStatus } from '../../api/types';

/** Statuses where a stop's address may change after assignment (dnm-work#108 Contract). */
const PICKUP_EDITABLE: readonly ShipmentStatus[] = ['ASSIGNED', 'EN_ROUTE_PICKUP'];
const DROP_EDITABLE: readonly ShipmentStatus[] = [
  'ASSIGNED',
  'EN_ROUTE_PICKUP',
  'AT_PICKUP',
  'LOADED',
  'IN_TRANSIT',
];

export const canEditPickup = (status: ShipmentStatus) => PICKUP_EDITABLE.includes(status);
export const canEditDrop = (status: ShipmentStatus) => DROP_EDITABLE.includes(status);
